// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section id="customer-term-deposits-create-details" class="box">

  <sub-header header="'Open new term deposit'"></sub-header>
  <form name="form">
        <validator condition="\$ctrl.hasValidOwnerConfiguration"></validator>

        <div class="info">
          <div class="info__field">
            <span class="key">Product name:</span>
            <span class="value">{{\$ctrl.termDepositProduct.productDefinition.productName}}</span>
          </div>
          <div class="info__field">
            <span class="key">Product subtype:</span>
            <span class="value">{{\$ctrl.termDepositProduct.depositGroup}}</span>
          </div>
          <div class="info__field">
            <span class="key">Interest range:</span>
            <span class="value">{{\$ctrl.termDepositProduct.interestRange}}</span>
          </div>
          <div class="info__field">
            <span class="key">Partial placement allowed:</span>
            <span class="value">{{\$ctrl.termDepositProduct.partialInitialPlacementAllowed | prettyBoolean}}</span>
          </div>
        </div>

        <table class="table">
          <tbody class="tbody">
          <tr>
            <td></td>
            <td>Term:</td>
            <td class="values">
              <div class="row-info-section">
                <glue-container prepend="'min.'" append="'days'">
                  <input
                    disabled
                    type="number"
                    ng-model="\$ctrl.termDepositProduct.minimalTerm"/>
                </glue-container>
              </div>
              <input
                ng-required="\$ctrl.termDepositProduct.depositSubgroup !== 'PLEDGE' || \$ctrl.termDeposit.pledgePaymentInterval === 'SINGLE_PAYMENT'"
                type="number"
                class="value"
                ng-model="\$ctrl.termDeposit.depositTerm"
                ng-change="\$ctrl.onDepositTermChange()"
                min="{{\$ctrl.termDepositProduct.minimalTerm}}"
                max="{{\$ctrl.termDepositProduct.maximumTerm}}"
                ng-disabled="\$ctrl.termDepositProduct.depositSubgroup === 'PLEDGE' && \$ctrl.termDeposit.pledgePaymentInterval !== 'SINGLE_PAYMENT'">
              <div class="row-info-section">
                <glue-container prepend="'max.'" append="'days'">
                  <input
                    disabled
                    type="number"
                    ng-model="\$ctrl.termDepositProduct.maximumTerm"/>
                </glue-container>
              </div>
              <div class="info text-info" ng-if="\$ctrl.termDepositProduct.depositSubgroup === 'PLEDGE'">
                <strong>Term and maturity date will be calculated automatically upon simulation or creation</strong>
              </div>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Maturity date:</td>
            <td class="values">
              <input
                type="text"
                disabled
                ng-value="\$ctrl.termDeposit.maturityDate | prettyDateWithDay"/>
              <div class="info text-info">
                Upon activation, Term and Maturity date could change if it falls on a holiday or non-working weekend.
              </div>
            </td>
          </tr>
          <tr ng-if="\$ctrl.termDepositProduct.depositSubgroup === 'PLEDGE'">
            <td></td>
            <td>Maturity value:</td>
            <td class="values">
              <cash
                ng-disabled="true"
                ng-model="\$ctrl.termDeposit.maturityValue"/>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>On maturity:</td>
            <td>
              <select
                ng-model="\$ctrl.termDeposit.maturityStrategy"
                ng-options="o.value as o.label for o in \$ctrl.termDepositProduct.maturityStrategies"
                ng-required="true">
              </select>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Interests withdrawal before maturity by:</td>
            <td>
              <select
                required
                ng-change="\$ctrl.onCreditingStrategyChange()"
                ng-model="\$ctrl.termDeposit.creditingStrategy"
                ng-options="o.value as o.label for o in \$ctrl.termDepositProduct.creditingStrategies">
              </select>
            </td>
          </tr>
          <tr ng-if="\$ctrl.termDeposit.creditingStrategy === 'PRODUCT_TRANSFER' || \$ctrl.termDeposit.maturityStrategy === 'RENEW_WITHOUT_INTEREST'
                        || \$ctrl.termDeposit.maturityStrategy === 'TRANSFER_TO_ACCOUNT'">
            <td></td>
            <td>Related account:</td>
            <td>
              <div>
                <selectize
                  options="\$ctrl.depositAccounts"
                  config="\$ctrl.selectAccountConfig"
                  ng-model="\$ctrl.termDeposit.relatedAccountId"
                  required>
                </selectize>
              </div>
            </td>
          </tr>
          <tr ng-if="\$ctrl.termDeposit.creditingStrategy !== 'NOT_ALLOWED'">
            <td></td>
            <td>Interests crediting interval</td>
            <td>
              <input
                required
                type="number"
                ng-model="\$ctrl.termDeposit.creditingInterval"
                min="1"
                max="{{\$ctrl.termDepositProduct.maximumTerm}}">
            </td>
          </tr>
          <tr ng-if="\$ctrl.termDeposit.creditingStrategy !== 'NOT_ALLOWED'">
            <td></td>
            <td>Interest crediting cycle type</td>
            <td>
              <select
                required
                ng-model="\$ctrl.termDeposit.creditingCycleType"
                ng-options="c.value as c.label for c in \$ctrl.cycleTypes">
              </select>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Tax exempted:</td>
            <td class="values">
              <select
                ng-disabled="!\$ctrl.overrideTaxExemption"
                ng-model="\$ctrl.termDeposit.taxExempted"
                boolean-options>
              </select>
              <div class="row-info-section">
                <label class="row-info-checkbox">
                  <input
                    type="checkbox"
                    ng-model="\$ctrl.overrideTaxExemption"/>
                  Override
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Override interest rate:</td>
            <td>
              <div>
                <select
                  required
                  ng-model="\$ctrl.termDeposit.depositInterest.specialInterestRate"
                  boolean-options>
                </select>
              </div>
            </td>
          </tr>
          <tr ng-if="\$ctrl.termDeposit.depositInterest.specialInterestRate">
            <td></td>
            <td>Interest rate:</td>
            <td class="values">
              <div>
                <glue-container append-percentage="true">
                  <input
                    required
                    min="0"
                    max="1000"
                    step="0.00001"
                    type="number"
                    ng-model="\$ctrl.termDeposit.depositInterest.interestRate"/>
                </glue-container>
              </div>
              <div class="row-info-section">
                <glue-container append-percentage="true">
                  <input disabled type="number" ng-model="\$ctrl.termDepositInterestBoard.basic.defaultRate"/>
                </glue-container>
              </div>
            </td>
          </tr>
          <tr ng-if="\$ctrl.termDeposit.depositInterest.specialInterestRate">
            <td></td>
            <td>Pretermination first half interest rate:</td>
            <td class="values">
              <div>
                <glue-container append-percentage="true">
                  <input
                    disabled
                    type="number"
                    ng-model="\$ctrl.termDeposit.depositInterest.preterminationFirstHalfInterestRate"/>
                </glue-container>
              </div>
              <div class="row-info-section text-info">
                25% of the overridden interest rate.
              </div>
            </td>
          </tr>
          <tr ng-if="\$ctrl.termDeposit.depositInterest.specialInterestRate">
            <td></td>
            <td>Pretermination second half interest rate:</td>
            <td class="values">
              <div>
                <glue-container append-percentage="true">
                  <input
                    disabled
                    type="number"
                    ng-model="\$ctrl.termDeposit.depositInterest.preterminationSecondHalfInterestRate"/>
                </glue-container>
              </div>
              <div class="row-info-section text-info">
                50% of the overridden interest rate.
              </div>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Casa class code:</td>
            <td>
              <select
                required
                ng-model="\$ctrl.termDeposit.casaClassCode"
                ng-options="o.value as o.label for o in \$ctrl.casaClassCodes">
              </select>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>PDIC type:</td>
            <td class="values">
              <select
                required
                ng-model="\$ctrl.termDeposit.pdicTypeId"
                ng-change="\$ctrl.pdicCasaTypesChanged()"
                ng-options="o.id as o.name for o in \$ctrl.pdicCasaTypes">
              </select>
            </td>
          </tr>
          <tr ng-if="\$ctrl.isCorporate">
            <td></td>
            <td>Signatories:</td>
            <td class="values">
              <multiselect
                           items="\$ctrl.signatoryRelatives"
                           ng-model="\$ctrl.termDeposit.signatoryIds"
                           label-property="'effectiveName'"
                           value-property="'id'">
              </multiselect>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Signature card:</td>
            <td class="values">
              <file-upload
                ng-model="\$ctrl.signatureCardFiles"
                validate-uploaded
                name="documentUpload"
                enable-webcam="false"
                show-remarks="true"
                show-file-name="true"
                max-files="1"
                allow-duplicates="false"
              ></file-upload>
            </td>
          </tr>
          <tr ng-if="\$ctrl.termDepositProduct.depositSubgroup === 'PLEDGE'">
            <td></td>
            <td>{{\$ctrl.getPledgeAmountLabel()}}</td>
            <td class="values">
              <cash
                ng-required="true"
                ng-model="\$ctrl.termDeposit.pledgeAmount"
                min="\$ctrl.termDepositProduct.minimalBalance">
              </cash>
            </td>
          </tr>
          <tr ng-if="\$ctrl.termDepositProduct.depositSubgroup === 'PLEDGE'">
            <td></td>
            <td>Pledge deposit interval:</td>
            <td class="values">
              <select
                ng-model="\$ctrl.termDeposit.pledgePaymentInterval"
                ng-options="o.value as o.label for o in \$ctrl.pledgePaymentIntervals"
                ng-change="\$ctrl.pledgePaymentIntervalChanged(\$ctrl.termDeposit.pledgePaymentInterval)"
                required>
              </select>
              <help ng-if="\$ctrl.termDeposit.pledgePaymentInterval === 'SINGLE_PAYMENT'"
                    title="Please provide term for single payment">
              </help>
            </td>
          </tr>
          <tr ng-if="\$ctrl.termDepositProduct.depositSubgroup === 'PLEDGE'">
            <td></td>
            <td>Pledge installment number:</td>
            <td class="values">
              <input type="number"
                     required
                     min="1"
                     max="500"
                     ng-model="\$ctrl.termDeposit.pledgeInstallmentNumber"
                     ng-change="\$ctrl.resetTerm()"
                     ng-disabled="\$ctrl.termDeposit.pledgePaymentInterval === 'SINGLE_PAYMENT'">
              <button type="button"
                      class="btn btn-default"
                      ng-click="\$ctrl.simulatePledge()"
                      ng-disabled="form.\$invalid">
                Pledge simulation
              </button>
            </td>
          </tr>
          </tbody>
        </table>

        <custom-field-input
          group="'DEPOSIT'"
          available-custom-fields="\$ctrl.termDepositProduct.productDefinition.customFieldDefinitionIds"
          assigned-category-ids="\$ctrl.termDeposit.categoryIds"
          custom-field-values="\$ctrl.termDeposit.customFieldValues"
          edit-mode="true"
          customer-id="\$ctrl.customerId">
        </custom-field-input>

        <div ng-if="\$ctrl.termDeposit.pledgeInstallments.length > 0">
          <h2 class="section-header">Pledge agreement schedule</h2>
          <pledge-installments
            installments="\$ctrl.termDeposit.pledgeInstallments"
            grace-period-days="\$ctrl.termDepositProduct.pledgeGracePeriodDays"
            simulation-mode="true">
          </pledge-installments>
        </div>

        <div ng-if="\$ctrl.multipleAccountOwnershipEnabled">
          <h2 class="section-header">Account owners</h2>
          <product-owners ownership="\$ctrl.termDeposit.ownership" edit-mode="true">
          </product-owners>
        </div>
      </form-section>

      <div ng-if="\$ctrl.termDepositProduct.depositSubgroup === 'PLEDGE'">
        <ada-auto-configuration-preview
          view="'TARGET'"
          customer-id="\$ctrl.customerId"
          definition-id="\$ctrl.termDepositProduct.productDefinition.id"
          condition-text="'After term deposit creation'">
        </ada-auto-configuration-preview>
      </div>

      <div class="pull-right">
        <button class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
        <button class="btn btn-primary" ng-click="\$ctrl.open()" ng-disabled="form.\$invalid">Open</button>
      </div>
  </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/new-term-deposit/new-term-deposit-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;